// components/TrustBadges/index.tsx — TrustBadges composition
import React from 'react';
import { buildBadges } from './badges';
import type { TrustBadgesProps } from './types';

const TrustBadges: React.FC<TrustBadgesProps> = ({ settings, className = '' }) => {
    if (!settings.active) return null;

    const badges = buildBadges(settings);
    const enabledBadges = badges.filter(badge => badge.enabled);

    if (enabledBadges.length === 0) return null;

    const layoutClass = settings.layout === 'grid'
        ? 'grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3'
        : 'flex flex-wrap justify-center gap-3';

    return (
        <div className={`trust-badges ${className}`}>
            <div className={layoutClass}>
                {enabledBadges.map(badge => (
                    <div
                        key={badge.key}
                        className="flex items-center gap-2 px-3 py-2 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg shadow-sm hover:shadow-md transition-shadow"
                    >
                        {settings.showIcons && (
                            <div className={badge.color}>
                                {badge.icon}
                            </div>
                        )}
                        <span className="text-xs font-medium text-slate-700 dark:text-slate-300">
                            {badge.text}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TrustBadges;
